import { useEffect, useState } from 'react';
import { modelTrialCasesListOnline } from '@/app/apis';
import type { ModelTrialCaseExample, ModelTrialCaseTaskType } from '@/app/types';
import { toModelTrialCaseExample } from '@/app/utils';

const EMPTY_EXAMPLES: ModelTrialCaseExample[] = [];

export const useModelTrialCases = (taskType: ModelTrialCaseTaskType, modelVersion: string, language: string) => {
  const key = `${language}:${taskType}:${modelVersion}`;
  const [result, setResult] = useState<{ key: string; examples: ModelTrialCaseExample[] }>();
  useEffect(() => {
    let active = true;
    const controller = new AbortController();
    modelTrialCasesListOnline({
      query: { language, task_type: taskType, model_version: modelVersion },
      signal: controller.signal,
    })
      .then(({ data, error }) => {
        if (active) setResult({ key, examples: error ? [] : (data?.cases ?? []).map(toModelTrialCaseExample) });
      })
      .catch(() => {
        if (active) setResult({ key, examples: [] });
      });
    return () => {
      active = false;
      controller.abort();
    };
  }, [key, taskType, modelVersion, language]);
  return result?.key === key ? result.examples : EMPTY_EXAMPLES;
};
